window.appModal = {
    _listeners: {},

    show: function (id, dotNetRef, closeOnEscape) {
        var el = document.getElementById(id);
        if (!el) return;

        var instance = bootstrap.Modal.getOrCreateInstance(el, {
            keyboard: closeOnEscape,
            backdrop: true
        });

        // Remove any prior hidden listener to avoid double-fire
        if (this._listeners[id]) {
            el.removeEventListener('hidden.bs.modal', this._listeners[id]);
        }

        var listener = function () {
            try {
                dotNetRef.invokeMethodAsync('OnModalHidden');
            } catch (e) {
                // DotNetObjectReference may be disposed during navigation
            }
        };
        this._listeners[id] = listener;
        el.addEventListener('hidden.bs.modal', listener);

        instance.show();
    },

    hide: function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        var instance = bootstrap.Modal.getInstance(el);
        if (instance) {
            instance.hide();
        }
    },

    dispose: function (id) {
        var el = document.getElementById(id);
        if (this._listeners[id]) {
            if (el) {
                el.removeEventListener('hidden.bs.modal', this._listeners[id]);
            }
            delete this._listeners[id];
        }
        if (el) {
            var instance = bootstrap.Modal.getInstance(el);
            if (instance) {
                instance.dispose();
            }
        }
    }
};
